import classNames from 'classnames'
import { FunctionComponent } from 'react'

import { Text } from '../primitives/Text/Text'
import { Icon } from '../primitives/Icon/Icon'
import { Image } from '../primitives/Image/Image'
import {
  UXComponentType,
  UXComponentVersion
} from '../UXComponentRenderer/uxComponent.types'
import { useActions } from 'src/hooks/useActions'
import { OrderCardSummary as OrderCardSummaryProps } from './OrderCardSummary.types'

import './OrderCardSummary.scss'

export const OrderCardSummary: FunctionComponent<OrderCardSummaryProps> = ({
  attributes,
  className
}) => {
  const { onClick } = useActions(attributes.actions)

  return (
    <button
      data-testid="core-ux-order-card-summary"
      className={classNames('core-ux-order-card-summary', className)}
      onClick={onClick}>
      {attributes.productIcons.map((productIcon, index) => {
        return (
          <Image
            className="core-ux-order-card-summary__image"
            type={UXComponentType.Image}
            version={UXComponentVersion.V2}
            attributes={{
              url: productIcon.url
            }}
          />
        )
      })}
      {attributes.remainingProductsQty && (
        <div className="core-ux-order-card-summary__item-remaining">
          <Text {...attributes.remainingProductsQty} />
        </div>
      )}
      {attributes.icon && (
        <Icon
          className="core-ux-order-card-summary__icon"
          {...attributes.icon}
        />
      )}
    </button>
  )
}
